import { useMemo } from "react";

import useEnabledProjectFields from "./useEnabledProjectFields";

/**
 * Field keys never offered in "Add Another Field to Card", even when enabled in project
 * field settings. Maintained independently from PDF exclusion lists.
 *
 * Omits `receiving_report_number` so Inbound Summary can be added to the card body.
 */
const STORE_CARD_ORDERED_FIELDS_EXCLUDED = [
  "created_at",
  "updated_at",
  "last_in",
  "last_out",
  "allocated_quantity",
  "in_cart_quantity",
  "reserved_quantity",
  "minimum_quantity",
  "available_quantity",
  "warehouse_quantity",
  "rack_locations",
  "item_id",
  "osd_notes",
  "general_notes",
  "customer_name",
  "outbound_summary",
  "photo",
  "attachments",
  "asset_label_pdf",
  "qr_code_image",
  "barcode",
  "barcode_number",
];

export default function useStoreCardFieldsRules(fieldSettings = null) {
  const enabledFields = useEnabledProjectFields(fieldSettings);

  return useMemo(
    () =>
      enabledFields
        .filter(([fieldName]) => !STORE_CARD_ORDERED_FIELDS_EXCLUDED.includes(fieldName))
        .sort((a, b) => (a[2] || "").localeCompare(b[2] || "")),
    [enabledFields]
  );
}
